// extracted by mini-css-extract-plugin
export default {"container":"bpl2AKpOjRPu2hlipKQo"};